import { connect } from "react-redux";
import { showInMaVachTaiSan } from "actions/InMaVachTaiSan";
import InMaVachTaiSan1 from "../../components/CommonComponent/InMaVachTaiSan/index1";

const mapStateToProps = (state) => ({
  inmavachtaisan: state.inmavachtaisan,
  camdo: state.camdo,
});

const mapDispatchToProps = (dispatch) => ({
  showInMaVachTaiSan: () => dispatch(showInMaVachTaiSan()),
});

export default connect(mapStateToProps, mapDispatchToProps)(InMaVachTaiSan1);
